module.exports = __webpack_public_path__ + "static/the-bed-of-procrustes-a4788a0c276f4a2f6d8fff793483012f.jpg";